import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth_not_required')({
  component: () => <Outlet />,
})
